import React from "react";
import { useFormik } from "formik";
import { useSelector } from "react-redux";
import Chip from "@material-ui/core/Chip";
import { isEmpty } from "lodash/fp";
import { selectGlobalSettings } from "../../../store/settingsStore/settingsSelectors";
import { Grid, IconButton, TextField } from "@material-ui/core";
import HorizontalPanel from "../../../components/HorizontalPanel";
import TransitEnterexitIcon from "@material-ui/icons/TransitEnterexit";
import { Toolbar } from "../../../app/components";
import { useTypedDispatch } from "../../../app/state";
import { setCoverageSettings, setFilterPanelVisibility } from "../../../store/filterStore/filterState";
import { validationSchema } from "./coverageValidation";
import useFilter from "../../../hooks/filter.hook";

import classes from './index.module.scss';

const CoverageSettings = () => {
  const dispatch = useTypedDispatch();
  const { state } = useFilter();
  const globalSettings = useSelector(selectGlobalSettings);
  const { powerLossCoefficient = '', interferenceLevel = '' } = globalSettings;
  const currentPowerLoss = state.coverageSettings.powerLossCoefficient || powerLossCoefficient;
  const currentInterferenceLevel = state.coverageSettings.interferenceLevel || interferenceLevel;

  const coverageFormik = useFormik({
    initialValues: {
      powerLossCoefficient: currentPowerLoss,
      interferenceLevel: currentInterferenceLevel,
    },
    validationSchema,
    onSubmit: () => {},
    enableReinitialize: true,
    validateOnChange: false,
    validateOnBlur: false,
  })

  const onCloseClick = () => {
    dispatch(setFilterPanelVisibility(null));
  }

  const onApply = async () => {
    const errors = await coverageFormik.validateForm();
    if (isEmpty(errors)) {
      dispatch(
        setCoverageSettings(coverageFormik.values)
      );
    }
  }

  const onClear = () => {
    dispatch(
      setCoverageSettings({
        powerLossCoefficient: null,
        interferenceLevel: null,
      })
    );

    coverageFormik.resetForm();
  }

  return (
    <HorizontalPanel size={HorizontalPanel.SIZES.WHOLE_SPACE}>
      <HorizontalPanel size={HorizontalPanel.SIZES.SMALL}>
        <Toolbar title="Coverage settings">
          <IconButton
            aria-label='close window'
            color='secondary'
            size='small'
            onClick={onCloseClick}
          >
            <TransitEnterexitIcon />
          </IconButton>
        </Toolbar>
      </HorizontalPanel>
      <HorizontalPanel size={HorizontalPanel.SIZES.REST_SPACE}>
        <Grid container spacing={2} className={classes.container}>
          <Grid item xs={12}>
            <TextField
              name="powerLossCoefficient"
              label="Power loss coefficient, dBm"
              variant='outlined'
              fullWidth
              required
              value={coverageFormik.values?.powerLossCoefficient}
              onChange={coverageFormik.handleChange}
              error={Boolean(coverageFormik?.errors?.powerLossCoefficient)}
              helperText={coverageFormik?.errors?.powerLossCoefficient}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              name="interferenceLevel"
              label="Interference level, dBm"
              variant='outlined'
              fullWidth
              required
              value={coverageFormik.values?.interferenceLevel}
              onChange={coverageFormik.handleChange}
              error={Boolean(coverageFormik?.errors?.interferenceLevel)}
              helperText={coverageFormik?.errors?.interferenceLevel}
            />
          </Grid>
          <Grid item xs={6} container justifyContent='flex-start'>
            <Chip
              disabled={!coverageFormik.dirty}
              label="Apply"
              color={'primary'}
              onClick={onApply}
            />
          </Grid>
          <Grid item xs={6} container justifyContent='flex-end'>
            <Chip
              label="Clear"
              color={'default'}
              onClick={onClear}
            />
          </Grid>
        </Grid>
      </HorizontalPanel>
    </HorizontalPanel>
  )
}

export default CoverageSettings;